module.exports = __webpack_public_path__ + "img/valleint4.a15446bc.png";